import React, { Component, createContext } from 'react'

//* HOCs
import { withRouter } from 'next/router'

//* Helpers
import { routerToPathAndQuery } from 'helpers'
import { ThemeProvider } from 'styled-components'
import themes from 'styles/theme'
import HelperClass from 'styles/helperClass'
import Variables from 'styles/variables'
import Typography from 'styles/typography'

const UIContext = createContext(null)

class UIProvider extends Component {
	//! States
	state = {
		winWidth: 1920,
		winHeight: 1080,
		loading: false,
		screenSizes: {
			screen3XL: '',
			screen2XL: '',
			screenXL: '',
			screenL: '',
			screenM: '',
			screenS: '',
			screenXS: '',
			popupIsOpen: false,
			popupComponent: null,
		},
		preloader: true,
		isBurgerMenuOpen: false,
	}

	//! Methods
	methods = {
		openPopup: this.openPopup.bind(this),
		closePopup: this.closePopup.bind(this),
		togglePopup: this.togglePopup.bind(this),
		toggleBurgerMenu: this.toggleBurgerMenu.bind(this),
		closeBurgerMenu: this.closeBurgerMenu.bind(this),
		getLoaderEnd: this.getLoaderEnd.bind(this),
		toggleLoading: this.toggleLoading.bind(this),
	}

	getLoaderEnd() {
		this.setState({ preloader: !this.state.preloader })
	}

	//! Toggle Loading
	toggleLoading(x) {
		this.setState({
			loading: x,
		})
	}

	//! Open Popup
	openPopup(popupComponent = null) {
		if (typeof popupComponent === 'string' && this.popup.includes(popupComponent) && this.props.router.query?.c !== popupComponent) {
			const { pathname, query } = routerToPathAndQuery(this.props.router, 'c', popupComponent)
			this.props.router.push({ pathname, query }, undefined, { shallow: true })
		}

		this.setState({
			popupIsOpen: true,
			popupComponent,
		})
	}

	//! Close Popup
	closePopup(scroll = false) {
		const { pathname, query } = routerToPathAndQuery(this.props.router, 'c')
		this.props.router.push({ pathname, query }, undefined, { scroll: false })

		this.setState({
			popupIsOpen: false,
			popupComponent: null,
		})
	}

	//! Toggle Popup
	togglePopup() {
		this.setState({
			popupIsOpen: !this.state.popupIsOpen,
		})
	}

	//! Query Popups Checking and Opening
	queryPopupsCheckAndOpen() {
		const popupQuery = this.props.router.query.c

		if (popupQuery && this.popup.includes(popupQuery) && this.state.popupComponent !== popupQuery) {
			this.openPopup(popupQuery)
		}
	}

	//! Query Popups Checking and Closing
	queryPopupsCheckAndClose(prevProps) {
		const popupQuery = this.props.router.query?.c

		if (!popupQuery && this.state.popupIsOpen && this.popup.includes(this.state.popupComponent)) {
			this.setState({
				popupIsOpen: false,
				popupComponent: null,
			})
		}
	}

	toggleBurgerMenu() {
		this.setState({ isBurgerMenuOpen: !this.state.isBurgerMenuOpen })
	}

	closeBurgerMenu() {
		this.state.isBurgerMenuOpen && this.setState({ isBurgerMenuOpen: false })
	}

	//! Screen Resize
	screenResize = () => {
		this.setState({
			winWidth: window.innerWidth,
			winHeight: window.innerHeight,
		})
	}

	//! Get Media Screen Sizes from Css Variables
	getScreenSizes() {
		const root = getComputedStyle(document.documentElement)

		const screenSizes = {
			screen3XL: parseInt(root.getPropertyValue('--screen3XL')),
			screen2XL: parseInt(root.getPropertyValue('--screen2XL')),
			screenXL: parseInt(root.getPropertyValue('--screenXL')),
			screenL: parseInt(root.getPropertyValue('--screenL')),
			screenM: parseInt(root.getPropertyValue('--screenM')),
			screenS: parseInt(root.getPropertyValue('--screenS')),
			screenXS: parseInt(root.getPropertyValue('--screenXS')),
		}

		this.setState({ screenSizes })
	}

	//! Component Did Mount
	componentDidMount() {
		this.setState({
			...this.state,
		})

		window.addEventListener('resize', this.screenResize)

		this.queryPopupsCheckAndOpen()
		this.getScreenSizes()
		this.screenResize()
	}

	//! Component Did Update
	componentDidUpdate(prevProps, prevState) {
		this.queryPopupsCheckAndOpen(prevProps)
	}

	//! Component Will Unmount
	componentWillUnmount() {
		window.addEventListener('resize', this.screenResize)
		document.removeEventListener('keydown', this.escKeydown, false)
		this.props.router.events.off('routeChangeComplete', this.queryPopupsCheckAndClose.bind(this))
	}

	render() {
		return (
			<UIContext.Provider value={{ ...this.state, ...this.methods }}>
				<ThemeProvider theme={themes}>
					<Variables />
					<Typography />
					<HelperClass
						isBurgerMenuOpen={this.state.isBurgerMenuOpen}
						isPreloaderPlay={this.state.preloader}
						isPopupOpen={this.state.popupIsOpen}
					/>
					{this.props.children}
				</ThemeProvider>
			</UIContext.Provider>
		)
	}
}

export default withRouter(UIProvider)
export const UIConsumer = UIContext.Consumer
